import { Component, OnInit, Input, AfterViewInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import swal from 'sweetalert2';
import { HttpService } from 'app/core/http/http.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { interval, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-create-update-commande',
  templateUrl: './create-update-commande.component.html',
  styleUrls: ['./create-update-commande.component.css']
})
export class CreateUpdateCommandeComponent implements OnInit,OnDestroy {

  // adminName:string="";
  // listeAdmin:any[]=[{
  //   nom:"YAO",
  //   prenom:"Kouassi",
  //   login:"yakou",
  //   contact:"09212109",
  //   statut:'COMMERCANT',
  //   createdAt:"10/10/2010"
  // }];
  // p:number=1
  @Input() commandeToUpdate;
  spinnerLoading:boolean=false;
  fraisEdition : number = 0;
  totalHT : number = 0;
  tva : number = 0;
  totalTTC : number = 0;
  periodOver = false;
  onClose: Subject<any> = new Subject<any>();
  
  createUpdateCommandeForm : FormGroup;

  firstStep = true;
  secondStep = false;
  adminEmail:string="";

  intervalSubscription: Subscription;


  paymentStatus:any = {
    "loading":false,
    "success":false,
    "failed":false
  }
  connectedUser: any;
  paymentTypes: any[] = [];
  feePercentage : number;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  otp: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '-',
    inputStyles: {},
    inputClass: 'otp-input'
  };
  CommandeID : number = 0;
  otpStep = false;
  paymentUrl : SafeResourceUrl;
  waitingLoading = false;
  constructor(public httpService:HttpService,private notification:NotificationService,public modalRef:BsModalRef,private formBuilder:FormBuilder, public sanitizer: DomSanitizer) { 

  }

  ngOnInit() {
    console.log("commande to update", this.commandeToUpdate);
    
    this.getCommandePaymentType()

    this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';
    this.feePercentage = this.connectedUser.Enseigne.PourcentageFraisEditionEcarte

    this.createUpdateCommandeForm = this.formBuilder.group({
      MontantCommande: [this.commandeToUpdate ? this.commandeToUpdate.MontantCommande : 0, [Validators.required,Validators.min(this.connectedUser.Enseigne.MontantMinCommandeEcarte || 0)]],
      MotifCommande: [this.commandeToUpdate ? this.commandeToUpdate.MotifCommande : "", Validators.required],
      MoyenDePaiementID: [this.commandeToUpdate ? this.commandeToUpdate.MoyenDePaiementID : 1, Validators.required],
    })

    this.calculateFees()
}
calculateFees(){
  this.fraisEdition = (this.MontantCommande.value * this.feePercentage) / 100;
  if(this.commandeToUpdate && this.commandeToUpdate.CommandeID){
    if(this.MontantCommande.value) {
      this.fraisEdition = (this.MontantCommande.value * this.feePercentage) / 100;
      //this.totalHT = this.MontantCommande.value + this.fraisEdition;
      this.tva = (this.httpService.tauxTVA / 100) * this.fraisEdition ;
      //this.totalTTC = this.totalHT + this.tva ;
    }
    else {
      this.fraisEdition = 0;
      this.tva = 0 ;
      this.totalTTC = 0 ;
    }
  }
  this.MontantCommande.valueChanges.subscribe(value => {
    if(value) {
      this.fraisEdition = (value * this.feePercentage) / 100;
      this.totalHT = value + this.fraisEdition;
      this.tva = (this.httpService.tauxTVA / 100) * this.totalHT ;
      this.totalTTC = this.totalHT + this.tva ;
    }
    else {
      this.fraisEdition = 0;
      this.tva = 0 ;
      this.totalTTC = 0 ;
    }
    
  })
}

get MontantCommande () {
  return this.createUpdateCommandeForm.get("MontantCommande");
}

get MoyenDePaiementID () {
  return this.createUpdateCommandeForm.get("MoyenDePaiementID");
}

get MotifCommande () {
  return this.createUpdateCommandeForm.get("MotifCommande");
}
    //console.log(this.typeUserCode);
    getCommandePaymentType(){
      let data = {
        "Index": 0,
        "Size": 10
        }
    
        this.httpService.execute("enseigne/getAllMoyenDePaiement", data).subscribe(res => {
          if(res.Data && res.Data.length) {
            this.paymentTypes = res.Data.filter(paymentType => {
              if(this.feePercentage === 0){
                return paymentType.MoyenDePaiementID === 3
              }
              return true
            })
          }
          else {
            this.paymentTypes = [];
          }
        })
    }
    closeModal(){
      this.modalRef.hide()
    }
    resetForm(){
      this.createUpdateCommandeForm.patchValue({
        MontantCommande : 0,
        MotifCommande : ""
      })
    }

    previous(){
      if(this.secondStep) {
        this.firstStep = true;
        this.secondStep = false;
      }
      else{
        this.secondStep = true;
        this.firstStep = false;
      }
      this.spinnerLoading = false
      this.otpStep = false;
    }

    createOrUpdateCommande(){

      if(this.firstStep){
        if(this.MontantCommande.errors){
          this.notification.smallBox({
            title: "Oops !",
            content: "Le montant de commande minimum est de "+ this.connectedUser.Enseigne.MontantMinCommandeEcarte + " F CFA",
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        return;
        }
        if(this.MotifCommande.errors){
          this.notification.smallBox({
            title: "Oops !",
            content: "Veuillez renseigner le motif de votre commande",
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        return;
        }
        this.firstStep = false;
        this.secondStep = true;
      }
      else if(this.secondStep){
        this.firstStep = false;
        this.secondStep = false;
        return;
      }
      else if(!this.spinnerLoading){
        //call api to create or update commande
        let commandeID = this.commandeToUpdate ? this.commandeToUpdate.CommandeID : ""
        let data = {
          ...this.createUpdateCommandeForm.value,
          CommandeID : commandeID
        }
        this.httpService.execute(commandeID ? "enseigneCommandeEcarte/update" : "enseigneCommandeEcarte/create", data).subscribe(res => {
          if (!res.HasError) {
            this.spinnerLoading = true;
            this.waitingLoading = true;
            this.CommandeID = res.Data.CommandeID
            if(this.MoyenDePaiementID.value === 2) {
              this.getPaymentUrl();
            }
            else if(this.MoyenDePaiementID.value === 3) {
                this.otpStep = true;
            }
            else {
              this.notification.smallBox({
                title: "Succès !",
                content: "Votre commande a été pris en compte. Elle sera effective après réception du montant de la commande sur le compte bancaire ",
                color: "#35a646",
                timeout: 6000,
                icon: "fa fa-check"
            });
            this.onClose.next(null);
            this.modalRef.hide();
            }
          } 
          else {
            this.notification.smallBox({
              title: "Oops !",
              content: res.message,
              color: "rgb(159, 0, 6)",
              timeout: 6000,
              icon: "fa fa-close"
          });
          }
        }, err => {
          this.notification.smallBox({
            title: "Oops !",
            content: err.Message,
            color: "rgb(159,0,6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        })
      }
      else {
        this.verifyOTP()
      }
    }

    getPaymentStatus(paymentRequestID){
      let paymentStatusData = {
          "PaymentRequestID": paymentRequestID
      }

      this.httpService.execute('enseigneCommandeEcarte/getPaymentStatus', paymentStatusData,{
        headers: { ignoreLoadingBar: '' }
      }).subscribe(res => {
        //console.log('check otp response', res);
        if (!res.HasError) {
          switch (res.Data.StatutID) {
            case 1:{
              this.paymentStatus.loading = true;
              this.paymentStatus.success = false;
              this.paymentStatus.failed = false;
              break;
            }
            case 2:{
              this.paymentStatus.loading = false;
              this.paymentStatus.success = true;
              this.paymentStatus.failed = false;
              this.intervalSubscription.unsubscribe();
              /*if(this.router.url === "/gift-payment") {
                this.notification.success('Succès !', "Votre paiement a été effectué avec succès");
              }
              else this.onClose.next({
                "success": true
              });*/
              this.onClose.next({
                "success": true
              });
              this.modalRef.hide();
              break;
            }
            case 3:{
              this.paymentStatus.loading = false;
              this.paymentStatus.success = false;
              this.paymentStatus.failed = true;
  
              this.intervalSubscription.unsubscribe();
              /*if(this.router.url === "/gift-payment") {
                this.notification.error('Oops !', res.Message);
              }
              else this.onClose.next({
                "success": false,
                "message": res.Message
              });*/
              this.onClose.next({
                "success": false,
                "message": res.Message
              });
              this.modalRef.hide();
              break;
            }
            default:
              break;
          }
  
        } else this.modalRef.hide();
      },
        err =>{
          // console.log("err",err);
          
          // this.modalRef.hide();
        });
    }
  
    checkPaymentStatus(paymentRequestID){
    this.intervalSubscription =  interval(5000)
    .pipe(takeUntil(timer(5*60*1000)))
    .subscribe(val => {
      //console.log(val)
      this.getPaymentStatus(paymentRequestID)
    },err =>{
  
    },
    ()=>{
      this.periodOver = true;
      this.intervalSubscription.unsubscribe();
      /*if(this.router.url === "/gift-payment") {
        this.notification.error('Oops !', "Le paiement n'a pas abouti car vous avez dépassé le délai d'attente maximum");
  
      }
      else this.onClose.next({
        "success": false,
        "message": "Le paiement n'a pas abouti car vous avez dépassé le délai d'attente maximum"
      });*/
      this.onClose.next({
        "success": false,
        "message": "Le paiement n'a pas abouti car vous avez dépassé le délai d'attente maximum"
      });
      this.modalRef.hide();
    });
    }

    getPaymentUrl(){
      const data = {
        Type: 1,//this.selectedImage['type'],
        CountryCode: "ci",
        Currency : "XOF",
        LanguageCode : "fr",
        CommandeID : this.CommandeID
      }
      this.httpService.execute('enseigneCommandeEcarte/getPaymentUrl', data).subscribe(res => {
        //console.log('check otp response', res);
        if (!res.HasError) {
          //window.open(res.Data.PaymentUrl,"_blank");
          this.waitingLoading = false;
          this.paymentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.Data.PaymentUrl);
          //this.setIframeUrl(res.Data.PaymentUrl)
          this.checkPaymentStatus(res.Data.PaymentRequestID);
          //this.getPaymentStatus(res.Data.PaymentRequestID);
        } else {
          this.notification.smallBox({
            title: "Oops !",
            content: res.message,
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        }
      },
        err =>{
          this.notification.smallBox({
            title: "Oops !",
            content: err.Message,
            color: "rgb(159,0,6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        });
    }
  /*setIframeUrl(url: any) {
    const iframe = this.hostElement.nativeElement.querySelector('iframe');
    iframe.src = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }*/

    resendOTP() {
      this.notification.smallBox({
        title: "Loading...",
        content: "Vous recevrez un nouveau code OTP dans quelques instants.",
        color: "#139fc2",
        timeout: 6000,
        icon: "fa fa-info-circle"
    });
    this.sendOTP()
    }

    sendOTP(){
      let data = {
        "CommandeID": this.CommandeID
      }
      this.httpService.execute('enseigneCommandeEcarte/sendOTP', data).subscribe(res => { 
        if(!res.HasError) {
          this.notification.smallBox({
            title: "Succès !",
            content: res.Message,
            color: "#35a646",
            timeout: 6000,
            icon: "fa fa-check"
        });
        }
        else {
          this.notification.smallBox({
            title: "Oops !",
            content: res.Message,
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        }
      },
        err => {
          this.notification.smallBox({
            title: "Oops !",
            content: err.Message,
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        });
    }
    onOtpChange(otp) {
      this.otp = otp;
    }

    verifyOTP() {
      const data = {
        CodeOTP: this.otp,
        "CommandeID": this.CommandeID
      };
      this.httpService.execute('enseigneCommandeEcarte/checkOTP', data).subscribe(res => {
        //console.log('check otp response', res);
        if (!res.HasError) {
          this.notification.smallBox({
            title: "Succès !",
            content: res.Message,
            color: "#35a646",
            timeout: 6000,
            icon: "fa fa-check"
        });
        this.onClose.next(null);
        this.modalRef.hide();
        } else {
          this.notification.smallBox({
            title: "Oops !",
            content: res.Message,
            color: "rgb(159, 0, 6)",
            timeout: 6000,
            icon: "fa fa-close"
        });
        }
      },
      err => {
        this.notification.smallBox({
          title: "Oops !",
          content: err.Message,
          color: "rgb(159, 0, 6)",
          timeout: 6000,
          icon: "fa fa-close"
      });
      });
    }

    ngOnDestroy(): void {
      this.intervalSubscription ? this.intervalSubscription.unsubscribe(): "";
    }

}
